import swal from "sweetalert";
import * as Toastr from "toastr";

export class ElcEmployeePrinting {
    constructor() {

        $('#checkAll').on('click',function(){
            var checkAll =  $('#checkAll').is(':checked')
            var count =  $('.employee_tag:checked').length;
            if(checkAll && count!= 0)
             $('#bulk-print-btn').removeAttr('disabled');
            else
             $('#bulk-print-btn').attr('disabled','disabled');
        });

        $('.employee_tag').on('click',function(){
            var count =  $('.employee_tag:checked').length;
            if(count > 0)
             $('#bulk-print-btn').removeAttr('disabled');
            else
             $('#bulk-print-btn').attr('disabled','disabled');
        });

        $('.emp-print').on('click', function(e){
            e.preventDefault();
            // Prevent people from being trigger happy
            var attr = $(this).attr('disabled');
            if(typeof attr == 'undefined') {
                $(this).attr('disabled', 'disabled');
                let _this = this;
                $.post(`${$(this).data('path')}?printer_id=${$('#selectedPrinter').val()}`, function(data) {
                    Toastr.success(data.message);
                    $(_this).removeAttr('disabled');
                });
            }
        });

        $('#bulk-print-btn').on('click', function(e) {
            e.preventDefault();
            // Prevent people from being trigger happy
            var attr = $(this).attr('disabled');
            if(typeof attr == 'undefined') {
                $(this).attr('disabled', 'disabled');
                let _this = this;
                let employee_ids = [];
                if($('.employee_tag:checked').length == 0) {
                    Toastr.error("No Employee Selected!");
                    $(_this).removeAttr('disabled');
                } else {
                    $('.employee_tag:checked').each( function(){
                        employee_ids.push($(this).val());
                    })
                    $.post(`${$(this).data('path')}?printer_id=${$('#selectedPrinter').val()}`, { employee_ids: employee_ids }).done(function(data) {
                        Toastr.success(data.message);
                        $(_this).removeAttr('disabled');
                    });
                }
            }
        });
    }
}
